import {
  buildPath,
  buildTemplatePath,
  CrudMode,
  Page,
  PageRoute,
  useParams,
  useUnsavedChanges,
  useValidationErrors,
} from "@compass/core";
import { Permission, User, UserEditResource, UserViewResource } from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { UserPageBody } from "./UserPageBody/UserPageBody";
import { UserPageHeader } from "./UserPageHeader";

const routeName = "user";

class Params {
  id: number = 0;
  crudMode: CrudMode = "view";
}

export const userPageRoute: PageRoute<Params> = {
  handle: "User",
  templatePath: buildTemplatePath(routeName, Params),
  getPath: (params) => buildPath(routeName, params),
};

export const UserPage = () => {
  const ROOT_PERMISSION: Permission = Permission.User;
  const navigate = useNavigate();
  const { params } = useParams(routeName, Params);
  const [user, setUser] = useState<User>({} as User);
  const { unsavedChanges, resetUnsavedChanges } = useUnsavedChanges({ trackedItems: [user] });
  const [editResource, setEditResource] = useState<UserEditResource>({});
  const [viewResource, setViewResource] = useState<UserViewResource>({});
  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    fetch(params.id);

    ApiService.users.getViewResource().then((response) => {
      setViewResource(response);
    });
  }, []);

  useEffect(() => {
    if (params.crudMode === "edit")
      ApiService.users.getEditResource().then((response) => {
        setEditResource(response);
      });
  }, [params.crudMode]);

  const reroute = (id: number, crudMode: CrudMode) =>
    navigate(`../${userPageRoute.getPath({ id: id, crudMode: crudMode })}`);

  const fetch = (id: number) => {
    ApiService.users.get(id).then((response) => {
      setUser(response);
      resetUnsavedChanges([response]);
    });
  };

  return (
    <Page
      isForm
      header={
        <UserPageHeader
          rootPermission={ROOT_PERMISSION}
          handle={userPageRoute.handle}
          crudMode={params.crudMode}
          reroute={reroute}          
          fetch={fetch}
          user={user}
          setValidationErrors={setValidationErrors}
          unsavedChanges={unsavedChanges}
        />
      }
    >
      <UserPageBody
        user={user}
        setUser={setUser}
        crudMode={params.crudMode}
        viewResource={viewResource}
        editResource={editResource}
        validationErrors={validationErrors}
      />
    </Page>
  );
};
